define('modules/accounts/users/modalCantCreate/view',['require','exports','module','views/BaseView','ldsh!./template'],function(require, exports, module) {
    "use strict";

    var BaseView = require("views/BaseView");

    var View = BaseView.extend({
        template: require("ldsh!./template"),
        initialize: function() {},
        serialize: function() {
            return {
                me: this.options.me
            };
        }
    });

    module.exports = View;
});

